import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import {
  ApplicationConfig,
  provideZonelessChangeDetection,
} from '@angular/core';
import {
  provideRouter,
  TitleStrategy,
  withComponentInputBinding,
} from '@angular/router';
import { AuthHttpInterceptor } from '@core/auth/auth.interceptor';
import { HttpInterceptor } from '@core/interceptors/http.interceptor';
import { TranslatedTitleStrategy } from '@core/services/translated-title.service';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { providePrimeNG } from 'primeng/config';
import { routes } from './app.routes';
import { MainTheme } from './config/theme';
import { provideAppServices } from './providers';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(
      withFetch(),
      withInterceptors([HttpInterceptor, AuthHttpInterceptor]),
    ),
    { provide: TitleStrategy, useClass: TranslatedTitleStrategy },

    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: './i18n/',
        suffix: '.json',
      }),
    }),
    providePrimeNG({
      theme: {
        preset: MainTheme,
        options: {
          darkModeSelector: '.dark',
        },
      },
    }),
    provideAppServices(),
  ],
};
